<mat-card>
  <app-kf-configuration-summary-table *ngIf="categorySummaryMappings"
    [countryYears]="countriesYears"
    [summaryMappings]="categorySummaryMappings"
    [classifierType]="'POM Category'"
    [showEmptyValues]="showCategoryEmptyValues"
    (downloadExcelFile)="downloadCategorySummaryExcel($event)"
    (loadData)="loadCategoryMappings($event)"
  ></app-kf-configuration-summary-table>
  <app-kf-configuration-summary-table
    [countryYears]="countriesYears"
    [summaryMappings]="collectionStreamSummaryMappings"
    [classifierType]="'Collection Stream'"
    [showEmptyValues]="showCollectionStreamEmptyValues"
    (downloadExcelFile)="downloadCollectionStreamSummaryExcel($event)"
    (loadData)="loadCollectionStreamMappings($event)"
  ></app-kf-configuration-summary-table>
</mat-card>
